
import React, { useEffect } from 'react';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Features } from '@/components/Features';
import { Pricing } from '@/components/Pricing';
import { CalendarShowcase } from '@/components/CalendarShowcase';
import { DownloadSection } from '@/components/DownloadSection';
import { Footer } from '@/components/Footer';
import ProtectedRoute from '@/components/ProtectedRoute';

const Index = () => {
  useEffect(() => {
    // Smooth scroll to anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        
        const href = this.getAttribute('href');
        if (!href) return;
        
        const target = document.querySelector(href);
        if (!target) return;
        
        window.scrollTo({
          top: (target as HTMLElement).offsetTop - 80, // Offset for fixed header
          behavior: 'smooth'
        });
      });
    });
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <Features />
      {/* Uncomment when CalendarShowcase is ready */}
      {/*<CalendarShowcase />*/}
      {/*<Pricing />*/}
      <DownloadSection />
      <Footer />
    </div>
  );
};

// Wrap the Index component with ProtectedRoute
const ProtectedIndex = () => (
  <ProtectedRoute redirectAuthenticated={true} redirectPath="/agenda">
    <Index />
  </ProtectedRoute>
);

export default ProtectedIndex;
